import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { StatusCount } from "@app/project/store/projects.state";
import { ClareStatusColors } from "@app/shared/model/clare-status.model";
import { NgChanges } from "@app/shared/model/ng-changes.model";
import { FilterType, IFilters } from "@app/shared/services/filter.service";

@Component({
    selector: "clare-status-filter",
    template: `<ng-container *ngFor="let status of statusCounts">
        <button
            id="status-{{ status.key }}"
            *letVar="isActiveFilter(status.key) as isActive"
            fxFlex
            class="btn-status {{ isActive ? 'active' : '' }}"
            (click)="onFilterChange(status.key)"
            [ngStyle]="{
                'border-color': colors[status.display],
                'background-color': isActive ? colors[status.display] : null
            }"
        >
            {{ status.value || 0 }} {{ status.display }}
        </button>
    </ng-container>`,
    styles: [
        `
            .btn-status {
                border-radius: 5px;
                white-space: nowrap;
                height: 45px;
                cursor: pointer;
                border: 2px solid transparent;
            }
            @media screen and (max-width: 599px) {
                .btn-status {
                    font-size: 80%;
                }
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClareStatusFilterComponent implements OnChanges {
    @Input() statusCounts: StatusCount[];
    @Input() filterColumn: FilterType;
    @Input() initialActiveFilters = [];
    @Output() private changeFilterHandler = new EventEmitter<IFilters>();

    public activeFilters: string[] = [];
    public readonly colors = ClareStatusColors;

    ngOnChanges(changes: NgChanges<ClareStatusFilterComponent>): void {
        if (changes.initialActiveFilters?.currentValue) {
            this.activeFilters = changes.initialActiveFilters.currentValue;
            this.changeFilterHandler.emit({ [this.filterColumn]: this.activeFilters || [] });
        }
    }

    /**
     * @description Determines whether the given filter is active or not
     * @param {string} filter the filter to check the status of
     * @returns {boolean} is the current filter active?
     */
    isActiveFilter(filter: string): boolean {
        return this.activeFilters.some(activeFilter => activeFilter === filter);
    }

    /**
     * @description Adds and removes filter keys from the active filters array.
     * Emits a changeFilter event when done.
     * @param {string} filterStr the filter key
     */
    onFilterChange(filterStr: string) {
        const ind = this.activeFilters.findIndex(filter => filter === filterStr);
        if (ind < 0) {
            this.activeFilters.push(filterStr);
        } else {
            this.activeFilters.splice(ind, 1);
        }
        this.changeFilterHandler.emit({ [this.filterColumn]: this.activeFilters || [] });
    }
}
